import { ITask as IWeddingTask } from '@bridebook/models/source/models/Weddings/Tasks.types';

// Must match `Weddings.Tasks.todayTaskGroupId` in packages/models. Duplicated
// here so this util (and its server-side call sites) don't pull the firebase
// client SDK through the models class.
const TODAY_TASK_GROUP_ID = '7a1bb849-a468-4313-8231-ac8f5eb7e6b6';

export const filterChecklistWeddingTasks = <T extends Pick<IWeddingTask, 'group'>>(
  tasks: Record<string, T>,
) =>
  Object.keys(tasks).reduce<Record<string, T>>((result, taskId) => {
    const task = tasks[taskId];

    // Mirror `Weddings.Tasks.query()`: exclude today-tasks and docs with no group.
    if (task.group == null || task.group === TODAY_TASK_GROUP_ID) {
      return result;
    }

    result[taskId] = task;
    return result;
  }, {});
